import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import { Analytics } from './pages/Analytics';
import { captureAttribution } from './lib/attribution';

captureAttribution();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
    <Analytics />
      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);